import { Link } from "react-router-dom";
import StarRating from "./StarRating"; // read-only version
import { packages } from "../data/packages"; // local data
import "./RecommendedPackages.css"; // make sure your updated CSS is imported

export default function RecommendedPackages({ category }) {
  // Get packages for this category
  const categoryPackages = packages[category] || [];

  // Sort by rating field and take top 3
  const topThree = [...categoryPackages]
    .sort((a, b) => (b.rating || 0) - (a.rating || 0))
    .slice(0, 3);

  if (!topThree.length) return null;

  return (
    <section className="recommended-section">
      <h3>⭐ Top Recommended Packages</h3>
      <div className="recommended-grid">
        {topThree.map((pkg) => (
          <div key={pkg.id} className="recommended-card">
            {/* Image */}
            <img
              src={pkg.image || `/images/${pkg.id}.jpg`}
              alt={pkg.title}
              className="recommended-image"
            />

            {/* Title */}
            <h4>{pkg.title}</h4>

            {/* Star rating */}
            <div className="star-rating">
              <StarRating rating={pkg.rating || 0} readOnly={true} size={18} />
            </div>

            {/* Description snippet if available */}
            {pkg.shortDescription && <p>{pkg.shortDescription}</p>}

            {/* Button always at bottom */}
            <Link
              to={`/packages/${category}/${pkg.id}`}
              className="btn-readmore"
            >
              View Details
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
